"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggsLoader = void 0;
const react_hooks_1 = require("@apollo/react-hooks");
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const ModelRegistry_1 = __importDefault(require("@opsbase/lib-data-model/ModelRegistry"));
const utils_1 = require("@opsbase/lib-time/utils");
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
const useDataTree_1 = __importDefault(require("../useDataTree"));
const useDataTreeActions_1 = __importDefault(require("../useDataTreeActions"));
const EMPTY_ARRAY = [];
function AggsLoader() {
    var _a, _b;
    const dt = (0, useDataTree_1.default)();
    const { setAggCollection } = (0, useDataTreeActions_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const lastLoaded = (0, react_1.useRef)();
    const skip = lastLoaded.current >= (0, utils_1.mostRecent)([view.groupsChanged, view.filtersChanged]);
    // -------------------------
    // PREPARE
    // -------------------------
    // Get details of View we want to query items for
    const { type } = view;
    const { aggQueryName } = MetaModelRegistry_1.default[type];
    const model = ModelRegistry_1.default[type];
    const dim1 = ((_a = view.groupBys) === null || _a === void 0 ? void 0 : _a.length) > 0 ? view.groupBys[0].queryFieldKey : undefined;
    const dim2 = ((_b = view.groupBys) === null || _b === void 0 ? void 0 : _b.length) > 1 ? view.groupBys[1].queryFieldKey : undefined;
    // -------------------------
    // BUILD THE QUERY
    // -------------------------
    const gqlStr = (0, graphql_tag_1.default) `
		query ${aggQueryName}($view: LMSS!, $dim1: String!, $dim2: String) {
			${aggQueryName}(view: $view, dim1: $dim1, dim2: $dim2)
		}
	`;
    const filters = [...view.filters];
    if (dt.baseFilter)
        filters.push(dt.baseFilter);
    const variables = { view: Object.assign(Object.assign({}, view), { filters }), dim1, dim2 };
    // -------------------------
    // PERFORM THE QUERY
    // -------------------------
    const { loading, data } = (0, react_hooks_1.useQuery)(gqlStr, {
        variables,
        skip,
        fetchPolicy: 'network-only',
    });
    // -------------------------
    // HANDLE THE RESPONSE
    // -------------------------
    const result = loading ? undefined : data === null || data === void 0 ? void 0 : data[aggQueryName];
    (0, react_1.useEffect)(() => {
        if (skip)
            return;
        if (!loading)
            lastLoaded.current = new Date();
        let aggs = !loading && !!result ? result : EMPTY_ARRAY;
        // Map Groups into Groups Array
        aggs.forEach(agg => {
            if (agg.dim1)
                agg.dim1 = dt.groupsById.get(agg.dim1.id);
            if (agg.dim2)
                agg.dim2 = dt.groupsById.get(agg.dim2.id);
        });
        setAggCollection({
            loading,
            lastLoaded: lastLoaded.current,
            aggs,
        });
    }, [dt.groupsById, loading, result, model, setAggCollection, skip]);
    return null;
}
exports.AggsLoader = AggsLoader;
exports.default = AggsLoader;
